// criteo-gokwik-bridge.js
// Import in theme.liquid via:
// <script src="{{ 'criteo-gokwik-bridge.js' | asset_url }}" defer></script>

(function () {
  "use strict";

  const CRITEO_ACCOUNT_ID = 125987;

  // ── Device type detection ──────────────────────────────────────────────
  const getDeviceType = () => {
    const ua = navigator.userAgent;
    if (/iPad/.test(ua)) return "t";
    if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(ua)) return "m";
    return "d";
  };

  // ── Criteo queue bootstrap ─────────────────────────────────────────────
  window.criteo_q = window.criteo_q || [];

  // ── Push helper (Instantly pushes to queue) ────────────────────────────
  const pushToCriteo = (events) => {
    window.criteo_q.push(
      { event: "setAccount",  account: CRITEO_ACCOUNT_ID },
      { event: "setSiteType", type: getDeviceType() },
      ...events
    );
  };

  // ── ID helpers ─────────────────────────────────────────────────────────
  const extractId = (gid) => {
    if (gid == null || gid === "") return null;
    const str = String(gid);
    const match = str.match(/\/(\d+)$/);
    return match ? match[1] : str;
  };

  const resolveItemId = (productId, sku) => {
    const fromGid = extractId(productId);
    if (fromGid) return fromGid;
    if (sku) return String(sku);
    return null;
  };

  const extractItems = (checkoutData) => {
    if (!checkoutData) return [];

    // 1. Try standard arrays of objects (line_items, lineItems, products, Products)
    const items = checkoutData.line_items ?? checkoutData.lineItems ?? checkoutData.products ?? checkoutData.Products;
    if (Array.isArray(items) && items.length > 0) {
      if (typeof items[0] === "object" && items[0] !== null) {
        const mapped = items
          .map((item) => {
            const id = resolveItemId(
              item.product_id ?? item.id ?? item.productId ?? item.variant_id ?? item.variantId,
              item.sku
            );
            if (!id) return null;
            return {
              id:       id,
              price:    parseFloat(item.price ?? item.price_store_currency) || 0,
              quantity: parseInt(item.quantity) || 1,
            };
          })
          .filter(Boolean);
        
        if (mapped.length > 0) {
          return mapped;
        }
      }
    }

    // 2. Try parallel arrays
    const productIds = checkoutData["Product ID"] ?? checkoutData["Product Variant ID"] ?? checkoutData["product_id"] ?? checkoutData["productId"];
    const productPrices = checkoutData["Product Price"] ?? checkoutData["price"];
    const productQuantities = checkoutData["Product Quantity"] ?? checkoutData["quantity"];

    if (Array.isArray(productIds) && productIds.length > 0) {
      return productIds
        .map((idVal, idx) => {
          const id = resolveItemId(idVal);
          if (!id) return null;
          
          const priceVal = Array.isArray(productPrices) ? productPrices[idx] : productPrices;
          const price = parseFloat(priceVal) || 0;
          
          const qtyVal = Array.isArray(productQuantities) ? productQuantities[idx] : productQuantities;
          const quantity = parseInt(qtyVal) || 1;

          return {
            id:       id,
            price:    price,
            quantity: quantity,
          };
        })
        .filter(Boolean);
    }

    return [];
  };

  // ── GoKwik postMessage listener ────────────────────────────────────────
  window.addEventListener("message", (event) => {
    try {
      let data = event.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // Ignore parsing errors for non-JSON postMessages
          return;
        }
      }

      if (!data || typeof data !== "object") return;

      const payload = data.data;
      const eventName = data.name || payload?.eventname;
      if (!eventName) return;

      // ── Started_Checkout_GK / begin_checkout → viewBasket ──────────────────
      if (eventName === "Started_Checkout_GK" || eventName === "begin_checkout") {
        if (!payload) return;
        const cartItems = extractItems(payload);
        if (!cartItems.length) return;
        console.log(eventName);
        
        pushToCriteo([{ event: "viewBasket", item: cartItems }]);
      }

      // ── Order_Placed_GK → trackTransaction ───────────────────────────────
      if (eventName === "Order_Placed_GK") {
        if (!payload) return;
        const orderId = String(
          payload.order_id ?? payload.order_name ?? payload.id ?? ""
        );

        if (!orderId) return;

        const purchasedItems = extractItems(payload);
        if (!purchasedItems.length) return;
        
        pushToCriteo([{
          event: "trackTransaction",
          id:    orderId,
          item:  purchasedItems,
        }]);
      }

      // ── sc_loaded → viewBasket ───────────────────────────────────────────
      if (eventName === "sc_loaded") {
        if (!payload) return;
        const cartItems = extractItems(payload);
        if (!cartItems.length) return;

        pushToCriteo([{ event: "viewBasket", item: cartItems }]);
      }
    } catch (error) {
      console.warn("Criteo GK Bridge: error processing event message", error);
    }
  });

})();